import { Map } from 'immutable';
import { pathSubscription, subscription } from 'nike-re-framejs';
import { updateCustomerSubscription as updateCustomerSubscriptionApi } from '../../components/notifications/nike-notification-server-api';

export const updateCustomerSubscription = (type, value) => db => {
    updateCustomerSubscriptionApi(type, value).catch(console.log);
    return db.updateIn(['notifications', 'customer'], customer => (value ? customer.add(type) : customer.delete(type)));
};

export const notifications$ = subscription(db => db.getIn(['notifications'], Map()));

export const customerSubscriptions$ = pathSubscription(['notifications', 'customer']);

export const subscriptionsSettingsTicketTracking$ = pathSubscription(['notifications', 'ticketTracking'], false);

export const subscriptionsSettingsPicksTracking$ = pathSubscription(['notifications', 'picksTracking'], false);

export const ticketSubscriptionsMap$ = pathSubscription(['notifications', 'tickets']);

export const ticketSubscription$ = ticketId => pathSubscription(['notifications', 'tickets', ticketId]);

export const matchSubscriptionsMap$ = pathSubscription(['notifications', 'match']);

export const betbookSubscription$ = authorNickname => pathSubscription(['notifications', 'betbook', authorNickname]);

export const matchNotificationTypes$ = matchId => pathSubscription(['notifications', 'types', 'match', matchId]);
